<template>
  <confirmation-card title="Delete tipping docket?" :subText="` (${tippingDocket.id})`">
    <v-btn color="grey darken-1" flat @click="close()">Cancel</v-btn>
    <v-btn
      flat
      @click="deleteTippingDocket()"
      color="red darken-1"
      :loading="loading"
    >Delete Tipping Docket</v-btn>
  </confirmation-card>
</template>

<script>
import TippingService from "@/services/requests/tippingService";
export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    deleteTippingDocket() {
      this.loading = true;
      TippingService.deleteMultipleTippingDockets({
        ids: [this.tippingDocket.id]
      })
        .then(result => {
          this.loading = false;
          this.snack({ text: "Tipping Docket was deleted!", color: "yellow" });
          this.close();
          this.$store.state.tipping.fetchTippingDockets = true;
        })
        .catch(err => {
          this.loading = false;
          this.snack({ text: err.response.data.message, color: "red" });
        });
    },
    close() {
      this.$emit("close");
    }
  },
  props: {
    tippingDocket: Object
  }
};
</script>